import FilePreviewDialog from '../FilePreviewDialog';

export default function HealthFilePreview(props) {
  return <FilePreviewDialog {...props} contentPath="/api/health/files/content" />;
}
